import type { ReactNode, RefObject } from 'react';

import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
} from '@nesso/ui/primitives/sheet';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    field: ReactNode;
    inputRef: RefObject<HTMLInputElement | null>;
};

export function SearchClientMobileView({ open, onOpenChange, field, inputRef }: Props) {
    return (
        <Sheet modal={false} open={open} onOpenChange={onOpenChange}>
            <SheetContent
                side="top"
                size="small"
                showCloseButton={false}
                className="flex h-auto max-h-dvh flex-col border-none bg-transparent p-0"
                onInteractOutside={(e) => e.preventDefault()}
                onOpenAutoFocus={(e) => {
                    e.preventDefault();
                    inputRef.current?.focus();
                }}
            >
                <SheetHeader className="sr-only">
                    <SheetTitle>Search clients</SheetTitle>
                    <SheetDescription>
                        Type a client's name to find them, then choose a result to open their chart.
                    </SheetDescription>
                </SheetHeader>
                {field}
            </SheetContent>
        </Sheet>
    );
}
